// src/components/UtilitiesPage.js

import React, { useState } from 'react';
import {
    Container,
    Typography,
    Box,
    Button,
    CircularProgress,
    Alert,
    Paper,
} from '@mui/material';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { getAuthToken } from '../utils/authToken';

export default function UtilitiesPage() {
    const tokenFromState = useSelector((state) => state.auth.token);
    const token = getAuthToken(tokenFromState);
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState('');

    const handleResetAllUsage = async () => {
        const confirmed = window.confirm(
            'Are you sure you want to reset ALL users’ DeepL usage back to 0?'
        );
        if (!confirmed) return;

        setLoading(true);
        setSuccessMsg('');
        setErrorMsg('');

        const authToken = getAuthToken(token);
        if (!authToken) {
            setErrorMsg('Authentication token missing. Please sign in again.');
            setLoading(false);
            return;
        }

        try {
            await axios.post(
                '/api/users/reset-usage',
                {},
                {
                    headers: { Authorization: `Bearer ${authToken}` },
                }
            );
            setSuccessMsg('✅ All users’ DeepL usage has been reset to 0.');
        } catch (err) {
            console.error('Error resetting usage:', err);
            setErrorMsg(
                err.response?.data?.message ||
                'Failed to reset usage. Please try again.'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 6 }}>
            <Paper sx={{ p: 4, borderRadius: 2, boxShadow: 3 }}>
                <Typography variant="h5" gutterBottom>
                    Admin Utilities
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                    Click the button below to zero‐out every user’s DeepL character usage.
                </Typography>

                {successMsg && (
                    <Alert severity="success" sx={{ mb: 2 }}>
                        {successMsg}
                    </Alert>
                )}
                {errorMsg && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {errorMsg}
                    </Alert>
                )}

                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleResetAllUsage}
                        disabled={loading}
                        startIcon={loading && <CircularProgress size={20} color="inherit" />}
                    >
                        {loading ? 'Resetting…' : 'Reset All DeepL Usage'}
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
}
